export const MODE = { 
    NEW: "NEW",
    EDIT: "EDIT",
    CLOSED: "CLOSED"
}